import GiftFlowRouting from './GiftFlowRouting';

export default GiftFlowRouting;
